import React from "react"

import NavLink from "./NavLink"

export type NavLinkNode = {
  readonly id: string
  readonly subLinks: NavLinkNode[]
  readonly link: JSX.Element
  readonly isCurrentPage?: boolean
  readonly hasCurrentPage?: boolean
  readonly position: number
}

type NavLinksProps = {
  nodes: NavLinkNode[]
  level: number
}

const NavLinks = ({ nodes, level }: NavLinksProps) => {
  // console.debug("Rendering NavLinks", nodes)

  return <>{nodes.map(node => node && <NavLink key={node.id} {...node} level={level} />)}</>
}

export default NavLinks
